<div class="body mt-5 pb-3">
      <div class="form-row mx-2 pb-3" *ngIf="formulaire">
        <div class="col" [formGroup]="rootForm">
          <h4 class="text-center ml-2 mt-2"><b><u>Synthèse des BAV saisis</u></b></h4>
          <h5 *ngIf="libelleJuridiction !== ''" class="text-left align-middle mt-5"><B>{{libelleJuridiction}}</B></h5>
          <p class="titreBav text-right mx-1 mt-3"><b>Nombre de BAV : </b><b><i>{{detailBavs.length}}</i></b></p>
                    <h5 class="mt-5 ml-2">G.1 - Les personnels de l'association en charge des activités de l'Aide Aux Victimes (tous dispositifs AAV), selon les fonctions, par effectif et ETPT</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec les tableaux A.1.a, A.1.b, A.1.c de la section A.1 de l'onglet ‘A – Les moyens’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th rowspan="2" class="text-center align-middle">Fonction</th>
                                  <th colspan="2" class="text-center align-middle">Tous BAV</th>
                                </tr>
                                <tr>
                                  <th class="text-center align-middle">Effectif 31/12</th>
                                  <th class="text-center align-middle">ETPT</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Accueillants Aide Aux Victimes</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbAav" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG1']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                        labelErreur="ctrlG1">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpAav" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG10']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                        labelErreur="ctrlG10">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Juristes</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbJur" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG2']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG2">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpJur" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG11']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG11">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Psychologues</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbPsy" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG3']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG3">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpPsy" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG12']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG12">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Travailleurs sociaux</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbWsoc" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG4']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG4">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpWsoc" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG13']">
                                    </bis-float-input-keypad>
                                     <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG13">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres intervenants</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbAutrInterv" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG5']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG5">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpAutrInterv" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG14']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG14">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Directeur, chef de service
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbDir" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG6']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG6">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpDir" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG15']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG15">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Comptable, secrétaire,
                                    personnel d'entretien</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbComptsecr" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG7']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG7">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpComptsecr" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG16']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG16">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres fonctions
                                    transversales et de support (ex : informaticien)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbAutrSupport" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG8']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG8">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpAutrSupport" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG17']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG17">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Ensemble des personnels</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotAaNbTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG9']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG9">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-float-input-keypad [rootForm]="formulaire" label="bavtotAaEtpTot" 
                                        classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG18']">
                                    </bis-float-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG18">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>

                    <h5 class="mt-5 ml-2">G.2.1 - L'origine du premier contact (victime ou non)</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau B.1 de l'onglet ‘B – Les premiers contacts’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Origine du contact</th>
                                  <th class="text-center align-middle">Tous BAV</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Démarche pro-active de
                                    l'association vers la personne</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactOrigAsso" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG19']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                       labelErreur="ctrlG19">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">A l'initiative de la personne
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactOrigPerso" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG20']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG20">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des origines premiers contacts</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactOrigTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" 
                                      [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG21']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG21">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.2.2 - Le mode de premier contact (victime ou non)</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau B.2 de l'onglet ‘B – Les premiers contacts’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Mode de contact</th>
                                  <th class="text-center align-middle">Tous BAV</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Courrier, courriel ou fax
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactModeEcrit" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG22']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG22">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Appel téléphonique</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactModeTel" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG23']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG23">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Présentation à la permanence
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactModePres" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG24']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG24">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des modes premiers contacts</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotBbPremContactModeTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" 
                                      libelle="vide" [erreursCroisees]="['ctrlG25']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG25">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.3.1 - Personnes reçues pour soutien et accompagnement : nature des faits</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau C.1 de l'onglet ‘C – Les personnes reçues’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th rowspan="2" class="text-center align-middle">Nature des faits</th>
                                  <th colspan="3" class="text-center align-middle">Tous BAV</th>
                                </tr>
                                <tr>
                                  <th class="text-center align-middle">Nombre total de personnes reçues</th>
                                  <th class="text-center align-middle">Dont accompagnées <br>(au moins 2 entretiens)</th>
                                  <th class="text-center align-middle">Nombre Total d'entretiens réalisés</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Faits pouvant avoir une
                                    qualification pénale</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVictNb" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG26']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG26">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVictSuivi" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG29']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG29">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVictEntret" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG32']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG32">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Faits n'ayant pas une
                                    qualification pénale</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuNvictNb" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG27']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG27">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuNvictSuivi" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG30']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG30">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuNvictEntret" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG33']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG33">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des personnes reçues</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuNbTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" 
                                      libelle="vide" [erreursCroisees]="['ctrlG28']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG28">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuSuiviTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" 
                                      libelle="vide" [erreursCroisees]="['ctrlG31']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG31">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotCcRecuEntretTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" 
                                      libelle="vide" [erreursCroisees]="['ctrlG34']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG34">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>
  
                    <h5 class="mt-5 ml-2">G.3.2 - Nombre de victimes d'infractions pénales reçues tous BAV</h5>
                    <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau C.2 de l'onglet ‘C – Les personnes reçues’
                    </div>
                    <fieldset class="ml-2 mr-2">
                      <div class="card rounded bg-light shadow pb-3" style="border-width:2px">
                        <div class="form-row mt-2 text-center">
                          <div class="col-md-8">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVict" classeSupplInput="text-center" 
                             [enLectureSeule]="true" classeColLabel="col-8" classeColInput="col-4">
                            </bis-integer-inline-input-keypad>
                          </div>
                        </div>
                        <div class="form-row text-center">
                          <div class="col-md-2"></div>
                          <div class="col-md-8">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVictPc" classeSupplInput="text-center" 
                             classeColLabel="col-8" classeColInput="col-4" [enLectureSeule]="true">
                            </bis-integer-inline-input-keypad>
                          </div>
                        </div>
                        <div class="form-row text-center">
                          <div class="col-md-2"></div>
                          <div class="col-md-8">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="bavtotCcRecuVictAud" classeSupplInput="text-center" 
                              [enLectureSeule]="true" classeColLabel="col-8" classeColInput="col-4">
                            </bis-integer-inline-input-keypad>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.4 - Contexte juridique des faits pour les victimes d'infractions pénales</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau D.1 de l'onglet ‘D – Les faits – procédure’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Infractions selon le contexte des faits</th>
                                  <th class="text-center align-middle">Nombre de victimes reçues</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"><b>1 - Atteintes aux
                                      personnes (hors accidents de la circulation)</b></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Homicides volontaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoHomiVolo" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG35']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG35">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Infractions à caractère
                                    sexuel (viols, agressions sexuelles, atteintes et harcèlements sexuels)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoSexuel" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG36']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG36">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Proxénétisme</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoProxe" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG37']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG37">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Violences volontaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoViolen" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG38']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG38">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoHomiInvolo" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG39']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG39">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Blessures involontaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoBless" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG40']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG40">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Abandons de famille (non
                                    paiement de la CEE, non représentation d'enfants...)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoAband" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG41']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG41">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Menaces, injures, harcèlement
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoMenace" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG42']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG42">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Discriminations</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoDiscri" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG43']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG43">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)<br><br>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoAutr" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG44']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG44">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total atteintes aux
                                      personnes </b>                                 
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitPersoTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" 
                                      libelle="vide" [erreursCroisees]="['ctrlG45']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG45">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"><b>2 - Atteintes aux biens
                                      (hors accidents de la circulation)</b></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Vol simple</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienVolSimp" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG46']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG46">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Vol aggravé</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienVolAggr" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG47']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG47">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Abus de confiance,
                                    escroquerie</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienEscro" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG48']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG48">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Destruction, dégradation</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienDegrad" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG49']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG49">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienAutr" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG50']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG50">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total atteintes aux biens
                                    </b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitBienTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" 
                                        [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG51']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG51">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"><b>3 - Accidents de la circulation</b></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires, blessures involontaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitCircuBless" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG52']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG52">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Dégâts matériels uniquement</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitCircuDegat" 
                                        classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG53']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG53">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total accidents de la circulation 
                                    </b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitCircuTot" classeSupplementaire="integer-input-total-affichage text-center" 
                                      [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG54']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG54">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"><b>4 - Autres infractions</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitAutr" classeSupplementaire="text-center" 
                                        [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG55']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG55">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des victimes reçues </b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotDdFaitTot" 
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG56']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG56">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>
  
                    <h5 class="mt-5 ml-2">G.5.1 - Les entretiens réalisés selon les thématiques dominantes</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau E.1 de l'onglet ‘E – Les aides apportées’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Thématiques dominantes</th>
                                  <th class="text-center align-middle">Nombre d'entretiens réalisés</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Dominante psychologique</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretPsy" 
                                        classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG57']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG57">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Dominante juridique</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretJur" 
                                        classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG58']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG58">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Dominante sociale</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretSoc" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide" [erreursCroisees]="['ctrlG59']">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG59">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Dominante écoute et soutien</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretEcout" [erreursCroisees]="['ctrlG60']" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG60">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autre
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretAutr" [erreursCroisees]="['ctrlG61']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG61">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des entretiens réalisés </b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeEntretTot" [erreursCroisees]="['ctrlG62']"
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG62">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.5.2 - Les diligences effectuées</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau E.2 de l'onglet ‘E – Les aides apportées’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Diligences auprès de</th>
                                  <th class="text-center align-middle">Nombre de diligences effectuées</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La juridiction (sauf CIVI)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliJur" [erreursCroisees]="['ctrlG63']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG63">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliCivi" [erreursCroisees]="['ctrlG64']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG64">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les fonds de garantie</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliFondGaran" [erreursCroisees]="['ctrlG65']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG65">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le service d'aide au recouvrement des victimes d'infraction (SARVI)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliSarvi" [erreursCroisees]="['ctrlG66']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG66">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le SPIP, les services pénitentiaires</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliPenit" [erreursCroisees]="['ctrlG67']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG67">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La police, la gendarmerie</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliPolgend" [erreursCroisees]="['ctrlG68']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG68">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Un avocat</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliAvoc" [erreursCroisees]="['ctrlG69']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG69">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Un commissaire de justice (ex Huissier)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliHuis" [erreursCroisees]="['ctrlG70']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG70">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les organismes sociaux (la sécurité sociale, la CAF…)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliOrgaSoc" [erreursCroisees]="['ctrlG71']" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG71">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les mairies, collectivités locales, CCAS</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliColter" [erreursCroisees]="['ctrlG72']" 
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG72">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La préfecture</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliPref" [erreursCroisees]="['ctrlG73']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG73">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Un organisme de logement</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliOrgaLogt" [erreursCroisees]="['ctrlG74']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG74">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Un lieu d'hébergement</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliHebgt" [erreursCroisees]="['ctrlG75']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG75">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les services médicaux et hospitaliers</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliHosto" [erreursCroisees]="['ctrlG76']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG76">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Une autre association</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliAsso" [erreursCroisees]="['ctrlG77']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG77">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les assurances</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliAssur" [erreursCroisees]="['ctrlG78']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG78">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les services d'accès au droit hors France services (point justice, maison de justice et du droit…)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliSad" [erreursCroisees]="['ctrlG79']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG79">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les France services</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliFrserv" [erreursCroisees]="['ctrlG80']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG80">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres dispositifs ou institutions
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliAutr" [erreursCroisees]="['ctrlG81']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG81">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des diligences effectuées </b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiliTot" [erreursCroisees]="['ctrlG82']"
                                      classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG82">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>
  
                    <h5 class="mt-5 ml-2">G.5.3 - Les aides auprès de la CIVI et du SARVI</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau E.4 de l'onglet ‘E – Les aides apportées’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Type d'aide apportée</th>
                                  <th class="text-center align-middle">Nombre de personnes reçues</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide à l'établissement de la requête devant la CIVI pour des dommages corporels et aux biens (706-3, 706-14 et 706-14-1 du CPP)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAideCivi" [erreursCroisees]="['ctrlG83']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG83">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier pour le SARVI</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAideSarvi" [erreursCroisees]="['ctrlG84']"
                                      classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                      labelErreur="ctrlG84">
                                    </bis-affiche-erreurs-croisees>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.5.4 - Nombre d'informations communiquées aux victimes d'infractions pénales durant l'année</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Cette section est en lien avec la section F.5.4 de l'onglet ‘F - Activité des BAV’
                    </div>
                    <h6 class="mt-3 ml-2">a - Sur la procédure en cours</h6>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th colspan="2" class="text-center align-middle">a-1 - PHASE PRÉ-SENTENCIELLE</th>
                                  <th colspan="2" class="text-center align-middle">a-2 - PHASE POST-SENTENCIELLE</th>
                                </tr>
                                <tr>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de la plainte</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenPlainte" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le contenu de la décision</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPostSentenDec" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">L'enquête, les poursuites engagées, l'instruction en cours</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenEnq" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le caractère définitif du jugement</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPostSentenDef" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le classement sans suite</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenCss" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de recours</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPostSentenRecour" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La constitution de partie civile</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenPc" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase post-sentencielle (hors recouvrement des dommages et intérêts)
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPostSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La juridiction saisie et/ou le déroulé de l'audience</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenAud" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur la procédure en cours en phase post-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPostSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase pré-sentencielle
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur la procédure en cours en phase pré-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeProcPreSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>
  
                    <h6 class="mt-5 ml-2">b - Sur la situation de l'auteur de l'infraction (plusieurs réponses possibles)</h6>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th colspan="2" class="text-center align-middle">b-1 - PHASE PRÉ-SENTENCIELLE</th>
                                  <th colspan="2" class="text-center align-middle">b-2 - PHASE POST-SENTENCIELLE</th>
                                </tr>
                                <tr>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le contrôle judiciaire</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenCj" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu fermé (incarcération, remise de peine, permission de sortie...)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenMilFer" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La détention provisoire</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenDp" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu ouvert (sursis probatoire, travail d'intérêt général, aménagement de peine, y compris DDSE...)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenMilOuv" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenFinDeten" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenFinDeten" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenFinMes" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenFinMes" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">
                                    <label mat-raised-button [matTooltip]="infobulle1" matTooltipClass="tooltip-large"
                                    matTooltipPosition="right">
                                    <b>Autres (y compris ARSE</b><i class="material-icons md-dark md-20" aria-hidden="true">
                                      info
                                    </i>
                                    </label>)
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur la situation de l'auteur de l'infraction en phase pré-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPreSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur la situation de l'auteur de l'infraction en phase post-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeAuteurPostSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h6 class="mt-5 ml-2">c - Sur le recouvrement des dommages et intérêts (plusieurs réponses possibles)</h6>
                    <fieldset class="ml-2 mr-2 pt-2">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th colspan="2" class="text-center align-middle">c-1 - PHASE PRÉ-SENTENCIELLE</th>
                                  <th colspan="2" class="text-center align-middle">c-2 - PHASE POST-SENTENCIELLE</th>
                                </tr>
                                <tr>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                  <th class="text-center align-middle">Informations communiquées portant sur</th>
                                  <th class="text-center align-middle">Nombre d'informations</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPreSentenCivi" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenCivi" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPreSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le SARVI</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenSarvi" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur le recouvrement des dommages et intérêts en phase pré-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPreSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les Commissaires de justice (ex Huissiers)</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenHuis" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Le JAP et le SPIP</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenJapSpip" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Les Fonds de garantie</td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenFondGar" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                  <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des informations communiquées sur le recouvrement des dommages et intérêts en phase post-sentencielle</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDiPostSentenTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <div class="breakafter"></div>
  
                    <h6 class="mt-5 ml-2">d - Sur le fonctionnement judiciaire en général</h6>
                    <fieldset class="ml-2 mr-2">
                      <div class="card rounded bg-light shadow pb-3" style="border-width:2px">
                        <div class="form-row mt-2">
                          <div class="text-center col-md-11">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="bavtotEeFoncJudic" classeSupplInput="text-center" 
                             [enLectureSeule]="true" classeColLabel="col-10" classeColInput="col-2">
                            </bis-integer-inline-input-keypad>
                          </div>
                        </div>
                      </div>
                    </fieldset>
  
                    <h5 class="mt-5 ml-2">G.5.5 - Les démarches spécifiques accomplies</h5>
                    <div class="alerteTableau pt-2 pb-2">
                      Ce tableau est en lien avec le tableau F.5.5 de l'onglet ‘F - Activité des BAV’
                    </div>
                    <fieldset class="ml-2 mr-2 pt-2 pb-3">
                      <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                          <div class="col-md-12">
                            <table id="table-C1" class="table table-sm m-0 table-bordered">
                              <thead class="thead-light">
                                <tr>
                                  <th class="text-center align-middle">Type de démarches spécifiques</th>
                                  <th class="text-center align-middle">Nombre de démarches spécifiques accomplies</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide au dépôt de plainte
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarPlainte" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution de dossiers d'aide juridictionnelle
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarAj" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier en vue de l'audience
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarAud" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Accompagnement physique aux audiences
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarAccomp" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier d'indemnisation
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarDi" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left align-middle pl-2" style="width: 35%">Autres démarches spécifiques accomplies
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarAutr" classeSupplementaire="text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-right align-middle pl-2" style="width: 35%"><b>Total des démarches spécifiques accomplies</b>
                                  </td>
                                  <td class="text-center align-middle pt-3" style="width: 15%">
                                    <bis-integer-input-keypad [rootForm]="formulaire" label="bavtotEeDemarTot" classeSupplementaire="integer-input-total-affichage text-center" [enLectureSeule]="true" libelle="vide">
                                    </bis-integer-input-keypad>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
        </div>
      </div>
  </div>
  <br><br>
